import React from "react";
import { Container, makeStyles, Paper, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(5),
  },
}));

function Terms() {
  const classes = useStyles();
  return (
    <Container maxWidth="xl">
      <Typography variant="h6" className="mb-4">
        Terms
      </Typography>
      <Paper elevation={0} className={classes.paperContainer}>
        <Typography variant="body1">
          By accessing this web site, you are agreeing to be bound by these web
          site Terms and Conditions of Use, all applicable laws and regulations,
          and agree that you are responsible for compliance with any applicable
          local laws. If you do not agree with any of these terms, you are
          prohibited from using or accessing this site. The materials contained
          in this web site are protected by applicable copyright and trade mark
          law.
        </Typography>
      </Paper>
    </Container>
  );
}

export default Terms;
